


































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CompanyDocumentInfo as ICompanyDocumentInfo } from "@/api/models/company-document-info";
import api from "@/getinfo-api";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";

@Component({ components: { TextField, CBlock } })
export default class CompanyRequisitesView extends Vue {
  @Prop() companyId!: string;
  documentInfo!: ICompanyDocumentInfo;
  data() {
    return {
      documentInfo: undefined
    };
  }

  getDocumentInformation() {
    api.CompanyApi.getDocumentInfo(this.companyId).then(
      (res: { data: ICompanyDocumentInfo }) => {
        this.documentInfo = res.data;
      }
    );
  }

  created() {
    this.getDocumentInformation();
  }
}
